window.updateVariantId = function() {
  console.log('variant updation loaded');
  // Handle variant selection for all product cards
  document.querySelectorAll('variant-selects').forEach((wrapper) => {
    const variantsEl = wrapper.querySelector('.js-product-variants');
    if (!variantsEl) return;

    const variants = JSON.parse(variantsEl.textContent || '[]');
    const productFormId = wrapper.dataset.productFormId;
    if (!productFormId) return;
    
    const form = document.getElementById(productFormId);
    if (!form) return;
    
    // Add event listeners to radio inputs
    wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const selectedOptions = Array.from(wrapper.querySelectorAll('fieldset')).map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : '';
        });

        // Find matching variant
        const matchedVariant = variants.find((v) =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (matchedVariant) {
          updateButtonState(matchedVariant, form);
          updateVariantLabels(matchedVariant, variants, wrapper);
        }
      });
      radio.addEventListener('click', ()=>{
        wrapper.querySelectorAll('label.variant-button').forEach((label) => {
          label.classList.remove('selected_checked')
        })
        const newRadio = wrapper.querySelector(`label.variant-button[for="${radio.id}"]`);
        if(newRadio) newRadio.classList.add('selected_checked');
        console.log(newRadio);
        addToCartButtonTrigger(form);
      })
    });

    // Trigger initial variant selection
    if (variants.length > 1) {
      const checkedRadios = wrapper.querySelectorAll('input:checked');
      if (checkedRadios.length > 0) {
        // Dispatch change event to initialize button state
        const event = new Event('change');
        checkedRadios.forEach((radio) => radio.dispatchEvent(event));
      } else {
        // Initialize with all variants to add classes
        // updateVariantLabels(null);
      }
    } else if (variants.length === 1) {
      // If only one variant, set it immediately
      updateButtonState(variants[0], form);
      updateVariantLabels(variants[0], variants, wrapper);
    }
  });
}

window.updateVariantId();

function addToCartButtonTrigger(form){
  const submitButton = form.querySelector('button[type="submit"]');
  if (!submitButton) return;
  setTimeout(()=>{
    submitButton.click();
  })
}

// Function to add classes to variant labels
function updateVariantLabels(matchedVariant, variants, wrapper) {
  // Remove all classes from all labels first
  wrapper.querySelectorAll('label.variant-button').forEach(label => {
    label.classList.remove('selected', 'sold-out', 'available');
  });

  // Add classes to all variant labels based on their state
  variants.forEach(variant => {
    // Find the labels for this variant
    variant.options.forEach((optionValue, optionIndex) => {
      const fieldset = wrapper.querySelectorAll('fieldset')[optionIndex];
      if (!fieldset) return;
      
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      const labels = fieldset.querySelectorAll('label');
      
      radios.forEach((radio, index) => {
        if (radio.value === optionValue) {
          const label = labels[index];
          
          // Add sold-out or available class
          if (!variant.available) {
            label.classList.add('sold-out');
          } else {
            label.classList.add('available');
          }
          
          // If this is the matched variant and this option is selected, add selected class
          if (matchedVariant && matchedVariant.id === variant.id && radio.checked) {
            label.classList.add('selected');
          }
        }
      });
    });
  });
}

// Function to update button state and variant classes
function updateButtonState(variant, form) {
  const hiddenIdInput = form.querySelector('[name="id"]');
  const submitButton = form.querySelector('button[type="submit"]');
    
    if (!hiddenIdInput || !submitButton) return;
  if (!variant) return;
  
  // Update the hidden input with the variant ID
  hiddenIdInput.value = variant.id;
  
  // Remove disabled attribute if exists
  hiddenIdInput.removeAttribute('disabled');
  
  // Get the button text element
  const btnIcon = submitButton.querySelector('.btn_icon');
  const buttonText = btnIcon ? btnIcon.querySelector('span') : null;
  
  // Update button state based on availability
  if (variant.available) {
    submitButton.disabled = false;
    submitButton.removeAttribute('data-sold-out-message');
    if (buttonText) {
      buttonText.textContent = 'Add to cart';
    }
    // Also update the sold-out message span
    const soldOutSpan = submitButton.querySelector('.sold-out-message');
    if (soldOutSpan) {
      soldOutSpan.classList.add('hidden');
    }
  } else {
    submitButton.disabled = true;
    submitButton.setAttribute('data-sold-out-message', 'true');
    if (buttonText) {
      buttonText.textContent = 'Sold out';
    }
    // Show the sold-out message span
    const soldOutSpan = submitButton.querySelector('.sold-out-message');
    if (soldOutSpan) {
      soldOutSpan.classList.remove('hidden');
    }
    // Disable the hidden input
    hiddenIdInput.setAttribute('disabled', 'disabled');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const allDetails = document.querySelectorAll('.collapsible-content details');

  allDetails.forEach((detail) => {
    const content = detail.querySelector('.collapsible-content .accordion__content');

    // Initial styles
    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.35s ease';
    content.style.maxHeight = detail.open ? content.scrollHeight + 'px' : '0px';

    // Use toggle event instead of click
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        // Close all other open accordions
        allDetails.forEach((other) => {
          if (other !== detail && other.open) {
            const otherContent = other.querySelector('.collapsible-content .accordion__content');
            otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
            requestAnimationFrame(() => {
              otherContent.style.maxHeight = '0px';
            });
            otherContent.addEventListener('transitionend', function handler() {
              other.removeAttribute('open');
              otherContent.removeEventListener('transitionend', handler);
            });
          }
        });

        // Smooth open for current one
        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
        });
      } else {
        // Smooth close for current one
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
      }
    });

    // Update height on resize (for open accordions)
    window.addEventListener('resize', () => {
      if (detail.open) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});


// document.addEventListener('DOMContentLoaded', () => {
//   const menuDetails = document.querySelectorAll('header-menu details');

//   menuDetails.forEach((detail) => {
//     detail.addEventListener('toggle', () => {
//       if (detail.open) {
//         // When opened → add class to body
//         document.body.classList.add('menu-open');
//       } else {
//         // When closed → check if any other menu is still open
//         const anyOpen = Array.from(menuDetails).some((d) => d.open);
//         if (!anyOpen) {
//           document.body.classList.remove('menu-open');
//         }
//       }
//     });
//   });
// });


function splitProductTitles() {
  const titles = document.querySelectorAll('.card__heading a');
  titles.forEach((title) => {
    const text = title.textContent.trim();

    if (text.includes('-') && !title.querySelector('span')) {
      const [before, after] = text.split('-').map(t => t.trim());
      title.innerHTML = `${before} <span class="product-subtitle">${after}</span>`;
    }
  });
}

// Run after DOM loads
document.addEventListener('DOMContentLoaded', () => {
  splitProductTitles();

  // Run again if products load dynamically
  const observer = new MutationObserver(() => splitProductTitles());
  observer.observe(document.body, { childList: true, subtree: true });
});



// header menu hover effect

(() => {
  const menuContainers = document.querySelectorAll('.mega-menu, .default-menu, .default_image_menu');

  // Open on hover
  document.querySelectorAll('.header__menu-item').forEach((menuItem) => {
    menuItem.addEventListener('mouseenter', () => {
      const parentMenu = menuItem.closest('.mega-menu, .default-menu, .default_image_menu');

      // Close all other menus
      menuContainers.forEach((otherMenu) => {
        if (otherMenu !== parentMenu) {
          otherMenu.removeAttribute('open');
          const otherItem = otherMenu.querySelector('.header__menu-item');
          if (otherItem) {
            otherItem.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Open current menu
      if (parentMenu) {
        parentMenu.setAttribute('open', '');
        menuItem.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ✅ Close when leaving the <details> element
  document.querySelectorAll('.mega-menu, .default-menu, .default_image_menu').forEach((menu) => {
    menu.addEventListener('mouseleave', () => {
      menu.removeAttribute('open');
      const menuItem = menu.querySelector('.header__menu-item');
      if (menuItem) {
        menuItem.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();


document.querySelectorAll('input, textarea').forEach((field) => {
  const toggleClass = () => {
    if (field.value.trim() !== '') {
      field.classList.add('has-text');
    } else {
      field.classList.remove('has-text');
    }
  };

  // Check on load
  toggleClass();

  // Listen for user input and changes
  field.addEventListener('input', toggleClass);
  field.addEventListener('change', toggleClass);
  field.addEventListener('blur', toggleClass);
});

//update See On Me text PDP
if(document.querySelector('.change-room-btn.modal-trigger span')) document.querySelector('.change-room-btn.modal-trigger span').innerHTML = 'See on Me';

window.initProductCardSwiper = function () {

  document.querySelectorAll('.product-card-swiper').forEach(function (el) {

    if (el.classList.contains('swiper-initialized') || el.swiper) return;

    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;

    const slidesToRemove = isDesktop
      ? '.mobile-only-media-slide'
      : '.desktop-only-media-slide';

    el.querySelectorAll(slidesToRemove).forEach((slide) => slide.remove());

    const slideCount = el.querySelectorAll('.swiper-slide').length;

    const nextBtn = el.querySelector('.swiper-button-next');
    const prevBtn = el.querySelector('.swiper-button-prev');

    // Hide buttons if only 1 slide
    if (slideCount <= 1) {
      if (nextBtn) nextBtn.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
      return;
    }

    // Show buttons if slider active
    if (nextBtn) nextBtn.style.display = '';
    if (prevBtn) prevBtn.style.display = '';

    new Swiper(el, {
      loop: slideCount > 1,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      effect: 'slide',
      speed: 500,
    });

  });


  document.querySelectorAll('.disable_hover_effect_image').forEach((swiper) => {

    swiper.querySelectorAll('img + img').forEach((img) => {

      img.style.setProperty('display', 'none', 'important');

    });

  });

};


// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  window.initProductCardSwiper();
});


// Shopify theme editor support
document.addEventListener('shopify:section:load', function () {
  window.initProductCardSwiper();
});

// Redirect to AU site if australia selected from country selector
const countrySelectors = document.querySelectorAll('.disclosure__list.country-selector__list');
countrySelectors.forEach(selector => {
  const countryList = selector.querySelectorAll('.popular-countries li');
  countryList.forEach(country => {
    country.addEventListener('click', function () {
      const link = country.querySelector('.disclosure__link');
      if (!link) return;
      const countryName = link.getAttribute('id');
      if (countryName === 'Australia') {
        window.location.href = 'https://www.astaresort.com.au/';
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const badgeContainers = document.querySelectorAll(".card-left-badges");

  badgeContainers.forEach((container) => {

    const badges = container.querySelectorAll(".almost-gone-badge");
    const total = badges.length;

    if (total === 0) return;

    if (total === 1) {
      badges[0].classList.add("active");
      return;
    }

    let index = 0;
    badges[0].classList.add("active");

    setInterval(() => {

      const current = badges[index];
      index = (index + 1) % total;
      const next = badges[index];

      current.classList.remove("active");
      current.classList.add("exit");

      setTimeout(() => {
        current.classList.remove("exit");
      }, 400);

      next.classList.add("active");

    }, 4000);
  });
});

// ---------- Collection Page Collection List ------------
const swiperContainer = document.querySelector('.sub-collection_wrapper .swiper-container');

const mySwiper = new Swiper(swiperContainer, {
  slidesPerView: 3,
  loop: false,
  loopAdditionalSlides: 30,
  spaceBetween: 10,
  scrollbar: {
    el: '.sub_collection_list .js-collection-scrollbar',
    draggable: true,
    snapOnRelease: true,
  },
  breakpoints: {
    569: {
      slidesPerView: 4
    },
    768: {
      slidesPerView: 5
    },
    1024: {
      slidesPerView: 6
    },
    1200: {
      slidesPerView: 8
    },
    1500: {
      slidesPerView: 11
    },
  },
});